import { LocalizedOptionsKeyType } from './types'
import { useLocalizedOptions } from './useLocalizedOptions'

export const useLocalizedOptionsValue = (
  localizedOptionsKey: LocalizedOptionsKeyType
) => {
  const localizedOptions = useLocalizedOptions()

  return localizedOptions[localizedOptionsKey]
}
